import StarIcon from 'assets/ver2/icons/star-outline-icon.svg';
import GiftImage from 'assets/ver2/images/gift-voucher.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  COMMON_PHONE,
  DESKTOP_MIN_WIDTH,
  HHMT_PHONE,
  HHMT_START_REGISTER_REQUIREDS,
  REMOX_PHONE,
  REMOX_START_REGISTER_REQUIREDS,
  TABLET_MAX_WIDTH,
} from 'constants';
import { format } from 'helpers';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import WelcomeMobilePopup from './mobile';

const WelcomePopup = ({
  isOpen,
  imageSrc = '',
  imagesStyles = {},
  text,
  content,
  alignContent = 'left' || 'center' || 'right',
  buttonLabel1,
  buttonLabel2,
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  isClickBackdropToClose = false,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();
  const { isHHMTTheme } = useTheme();

  const handleOnClickBackdropToClose = () => {
    if (isClickBackdropToClose) {
      onClose();
    }
  };

  const renderBannerImage = () => (
    <BannerImage src={t('link_register_welcome_banner_image') || GiftImage} />
  );

  const renderParagraphWrap = () => (
    <Paragraph>
      {t('label_register_and_complete_to_earn')}
      <span>{t('label_$15_voucher')}</span>
    </Paragraph>
  );

  const renderBesidesWrap = () => (
    <BesidesWrap>
      <BesideItem>
        <BesideIcon src={StarIcon} width={16} height={16} />
        <BesideContent>{t('label_beside_content_1')}</BesideContent>
      </BesideItem>
      <BesideItem>
        <BesideIcon src={StarIcon} width={16} height={16} />
        <BesideContent>{t('label_beside_content_2')}</BesideContent>
      </BesideItem>
      <BesideItem>
        <BesideIcon src={StarIcon} width={16} height={16} />
        <BesideContent>{t('label_beside_content_3')}</BesideContent>
      </BesideItem>
    </BesidesWrap>
  );

  const renderRegisterRequireWrap = () => (
    <RegisterRequireWrap>
      <RegisterRequireTitle
        isHHMTTheme={isHHMTTheme}
        dangerouslySetInnerHTML={{
          __html: t('registration_text_check_below_information'),
        }}
      />
      {(isHHMTTheme
        ? HHMT_START_REGISTER_REQUIREDS
        : REMOX_START_REGISTER_REQUIREDS
      ).map((item, i) => (
        <RegisterRequireItem key={i}>
          <img src={item.imgUrl} width={40} height={40} />
          <RegisterRequireContent>{t(item.label)}</RegisterRequireContent>
        </RegisterRequireItem>
      ))}
    </RegisterRequireWrap>
  );

  const renderButtonsWrap = () => (
    <>
      <ButtonCommon
        value={t('button_register_now')}
        color="var(--ds-c-blue)"
        background="var(--ds-c-white)"
        borderNameVariable="--border-filter"
        isFill={false}
        styles={{
          margin: '0px',
          marginInline: 'auto',
          width: '100%',
        }}
        isCapitalize
        onClick={onClick}
        isUseKeyDown
      />
    </>
  );

  const renderContactUsWrap = () => (
    <ContactUsWrap>
      {t('registration_text_call_us')}
      {/* {!isDesktop && <SizeBox height={4} />} */}
      <span>
        <a href={`tel:${isHHMTTheme ? HHMT_PHONE : REMOX_PHONE}`}>
          {isHHMTTheme
            ? t('registration_text_hhmt_landline_1')
            : t('registration_text_remox_landline')}
        </a>{' '}
        -{' '}
        <a href={`tel:${COMMON_PHONE}`}>
          {format.toMobileNumberStr(COMMON_PHONE)}
        </a>
      </span>
    </ContactUsWrap>
  );

  if (!isDesktop)
    return (
      <WelcomeMobilePopup
        isOpen={isOpen}
        onClose={handleOnClickBackdropToClose}
        renderBannerImage={renderBannerImage}
        renderParagraphWrap={renderParagraphWrap}
        renderBesidesWrap={renderBesidesWrap}
        renderRegisterRequireWrap={renderRegisterRequireWrap}
        renderButtonsWrap={renderButtonsWrap}
        renderContactUsWrap={renderContactUsWrap}
      />
    );
  return (
    <>
      <style>
        {zIndexModal
          ? `
            @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
              .modal {
                z-index: ${zIndexModal || 1101};
              }
            }
          `
          : ``}

        {isBackdropOverlap
          ? `
            .welcome-modal-backdrop {
              z-index: ${zIndexBackdropOverlap || 1100}!important;
              background: #212121;
              opacity: 0.7!important;
              display: initial!important;
            }
          `
          : `
            .welcome-modal-backdrop {
              z-index: 1;
              background: #212121;
              opacity: 0.7!important;
              display: initial!important;
            }
          `}

        {`
          .welcome-modal-backdrop{
            @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
              height: calc(100vh - 72px)!important;
              top: unset!important;
              bottom: 0!important;
            }
          }
        `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={handleOnClickBackdropToClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="welcome-modal-backdrop"
        centered={true}
      >
        <ModalBody>
          <GridLayout>
            <GridItem>{renderBannerImage()}</GridItem>
            <GridItem $isCenter={true} style={{ paddingInline: '24px' }}>
              <SizeBox height={20} />
              {renderParagraphWrap()}
              <SizeBox height={20} />
              {renderBesidesWrap()}
              <SizeBox height={20} />
              {renderRegisterRequireWrap()}
              <SizeBox height={40} />
              {renderButtonsWrap()}
              <SizeBox height={100} />
              {renderContactUsWrap()}
            </GridItem>
          </GridLayout>
        </ModalBody>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    margin: 0;
    & .modal-content {
      padding: 16px;
      padding-top: 56px;
      border-radius: 0px;
      box-shadow: none;
      background: var(--ds-c-white);
      width: 100%;
      height: calc(100dvh - 70px);
      margin-inline: auto;
      border: none;
      top: 70px;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    top: 72px;
    margin: unset;
    & .modal-dialog {
      max-width: unset;
      max-height: unset;
      margin: 0;
      margin-top: -36px;
      & .modal-content {
        padding: 20px 0px 20px 20px;
        width: 1130px;
        max-width: 1130px;
        height: fit-content;
        border-radius: 40px;
        top: 0;
      }
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  padding-bottom: 100px;
  text-align: left;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-bottom: 0px;
  }
`;
const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    grid-template-columns: 648px 462px;
    gap: 0px;
  }
`;
const GridItem = styled.div`
  width: 100%;
  height: 100%;

  ${(props) =>
    props.$isCenter &&
    `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  `}
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 30px;
`;
const Paragraph = styled.p`
  ${paragraphMixin};
  font-size: 20px;
  line-height: 25px;
  color: #000;
  display: block;
  & span {
    font-weight: 700;
    border-radius: 4px;
    background: var(--ds-c-yellow);
    padding-inline: 10px;
    margin-left: 8px;
    height: 24px;
    color: #000;
  }
`;

const BesidesWrap = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 10px;
  width: 100%;
  padding: 10px;
  background: #f3f4f6;
  border-radius: 10px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding: 10px;
  }
`;
const BesideItem = styled.div`
  width: 100%;
  height: 16px;
  display: flex;
  gap: 4px;
  align-items: start;
  height: fit-content;
  padding-inline: 0px;
`;
const BesideIcon = styled.img``;
const BesideContent = styled.p`
  ${paragraphMixin};
  color: #000;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
`;

const RegisterRequireWrap = styled.div`
  display: grid;
  gap: 16px;
  padding: 10px;
  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    gap: 20px;
  }
`;
const RegisterRequireItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
`;
const RegisterRequireTitle = styled.p`
  ${paragraphMixin};

  span {
    color: ${(props) =>
      props.isHHMTTheme ? 'var(--ds-c-yellow)' : 'var(--ds-c-sky)'};
  }
`;
const RegisterRequireContent = styled.p`
  ${paragraphMixin};
  font-weight: 500;
`;

const ContactUsWrap = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: grid;
  grid-gap: 4px;
  text-align: center;
  & span {
    margin: 0;
    margin-left: 0px;
    font-size: 16px;
    line-height: 20px;
  }
  & a {
    color: #002ff1;
    text-decoration: none;
    &:hover {
      color: var(--ds-c-blue-hyperlink-hover) !important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: flex;
    justify-content: start;
    align-items: center;
    text-align: left;
    & span {
      margin-left: 4px;
    }
  }
`;

export default WelcomePopup;
